import { useAtomValue } from "jotai";
import type { IJWTUserPayload } from "../interfaces/JWTUserPayload";
import { accessTokenStore } from "../services/authentication-service/stores/access-token/access-token.store";

function useAccessToken(): IJWTUserPayload | undefined {
  return useAtomValue(accessTokenStore);
}

export default useAccessToken;
